<template>
  <el-menu class="navbar" mode="horizontal" :class="!sidebar.opened?'margin-ave':''">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <div class="right-menu">
      <lang-select class="right-menu-item hover-effect"/>

      <el-tooltip class="item" effect="dark" :content="content" placement="top-start">
        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <img src="@/assets/images/profile.jpg" class="user-avatar">
            <i class="el-icon-caret-bottom"/>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item style="pointer-events:none;cursor: not-allowed">
              <span style="display:block;">{{userName}}</span>
            </el-dropdown-item>
            <router-link to="/profile/index">
              <el-dropdown-item>修改密码</el-dropdown-item>
            </router-link>
            <!--<router-link to="/">-->
            <!--<el-dropdown-item>root</el-dropdown-item>-->
            <!--</router-link>-->

            <!--<el-dropdown-item divided @click.native="drawer = true">-->
            <!--<span style="display:block;">应用切换</span>-->
            <!--</el-dropdown-item>-->

            <el-dropdown-item divided @click.native="logout">
              <span style="display:block;">退出登录</span>
            </el-dropdown-item>

          </el-dropdown-menu>
        </el-dropdown>
      </el-tooltip>
    </div>
  </el-menu>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Breadcrumb from '@/components/Breadcrumb'
  import Hamburger from '@/components/Hamburger'
  import RightPanel from '@/components/RightPanel'
  import Screenfull from '@/components/Screenfull'
  import LangSelect from '@/components/LangSelect'

  import bus from '@/utils/bus'
  import {removeToken} from "@/utils/auth"; // 验权
  export default {
    data() {
      return {
        content: "root",
      }
    },
    components: {
      Breadcrumb,
      Hamburger,
      Screenfull,
      RightPanel,
      LangSelect
    },
    computed: {
      ...mapGetters([
        'sidebar',
        'avatar',
        'device',
        'userName'
      ])
    },


    methods: {
      onDrawer() {
        bus.$emit('onDrawer', true);
      },

      toggleSideBar() {
        this.$store.dispatch('ToggleSideBar')
      },
      open() {
        this.$confirm('确认要退出吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'messageBox',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('user/logOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })

        }).catch(() => {
        });
      },
      logout() {
        this.open();
      },
      changeLanguage(v) {
        this.$i18n.locale = v;
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  .navbar.margin-ave{
    transition:margin-left .3s;
    margin-left: 40px !important;
  }

  .navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;
    left: 0px;
    right: 0px;
    top: 0;
    padding-top: 50px;
    margin-left: 180px !important;
    position: fixed;
    z-index: 2003;
    min-width: 1280px;

    .hamburger-container {
      line-height: 58px;
      height: 50px;
      float: left;
      padding: 0 10px;
    }

    .right-menu {
      float: right;
      height: 100%;
      line-height: 50px;

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background .3s;

          &:hover {
            background: rgba(0, 0, 0, .025)
          }
        }
      }

      .avatar-container {
        margin-right: 30px;

        .avatar-wrapper {
          margin-top: 5px;
          position: relative;

          .user-avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }

          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }


  .box-item {
    display: flex;
    /*justify-content: center;*/
    align-items: center;
    border-radius: 4px;
    min-height: 30px;
    padding: 0 10px;
    background: #FAF9FA;
    cursor: pointer;
    margin-bottom: 10px;
    white-space: nowrap; /*强制文本一行显示*/
    overflow: hidden; /*超出元素默认宽度内容隐藏*/
    text-overflow: ellipsis; /*使用省略号代表有内容未显示*/
    font-size: 13px;
    line-height: 35px;
  }

  .box-item:hover {
    background: #f4f3f4;
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue